import React from "react";
import { useState, useEffect } from "react";
import { LocationOn } from "@mui/icons-material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import discount from "../../../assets/discount.svg";
import ConditionalRenderer from "../../../devsathan_components/ConditionalRenderer";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import DateSection from "../CardComponents/DateSection";
import { pushGTMEvent } from "../../../utils/GTMEventComponent";
import { BOOK_PUJA_PARTICIPATE_LANDING_PAGE } from "../../../utils/gtmEventConstants";
import parse from "html-react-parser";
import { useSelector } from "react-redux";

const EventCard = ({ event, eventtype, width, onButtonClick }) => {
  const eventStatus = event.eventType;
  const isInProgress = eventStatus === "INPROGRESS_EVENT";
  const isUpcoming = eventStatus === "UPCOMING_EVENT";
  const isEnded = eventStatus === "EVENT_END";

  const itemImages = event?.offeringItemImageList || [];

  const [positions, setPositions] = useState(
    itemImages.map((_, index) => index)
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setPositions((prev) => {
        const [first, ...rest] = prev;
        return [...rest, first];
      });
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const translations = useSelector((state) => state.language.translations);

  return (
    <div
      className={`flex flex-col justify-between w-full max-w-lg  max-h-lg bg-custom-beige rounded-3xl overflow-hidden shadow-lg h-full pb-4 ${width}`}
    >
      {/* Image Container */}
      <div>
        <div className="relative ">
          <div className="aspect-[5/3] w-full">
            <img
              src={event?.mainSection?.titleImageInfo?.url}
              alt={event?.mainSection?.titleImageInfo?.altText}
              className="w-full h-full object-cover"
            />
          </div>

          {/* Overlay Elements */}
          {!!event.attendeeStatusText && (
            <div className="absolute -top-4 -left-3 bg-[#E59419] text-white px-3 py-1 rounded-full rounded-bl-none text-xs sm:text-sm flex items-center gap-1">
              <div className="flex items-center gap-1 ml-3 mt-5 mb-0 mr-2">
                <span>
                  <TrendingUpIcon fontSize="small" /> {event.attendeeStatusText}
                </span>
              </div>
            </div>
          )}

          <ConditionalRenderer componentKey="whatsappbutton">
            <button className="absolute top-2 right-2 bg-green-500 text-white rounded-full p-3 flex items-center justify-center">
              <WhatsAppIcon />
            </button>
          </ConditionalRenderer>

          {event?.mainSection?.discountText && (
            <div className="absolute bottom-0 left-0 right-0 bg-[#BA1A1A] text-white text-center p-1 flex items-center justify-center rounded-b-3xl">
              <img src={discount} alt="" className="mr-1 h-5" />
              <span className="text-sm sm:text-[18px] md:text-[16px] p-1 ">
                {event.mainSection.discountText}
              </span>
            </div>
          )}
          {!isInProgress && eventStatus && (
            <div className="absolute inset-0  bg-opacity-50 backdrop-blur-md flex items-center justify-center">
              <span className="text-white font-bold text-lg sm:text-xl">
                {isUpcoming
                  ? "Upcoming Event"
                  : isEnded
                  ? "Event Ended"
                  : eventStatus.replace("_", " ")}
              </span>
            </div>
          )}
        </div>

        {/* Content */}
        <div className="p-4 flex flex-col gap-3">
          {/* Date and Time */}
          <DateSection eventDateTime={event?.eventDateTime} />
          {/* Title and Descripti on */}
          <div>
            <h3 className="text-lg sm:text-xl font-bold text-[#3A0B01] mb-1 text-wrap">
              {event.mainSection.name}
            </h3>
            <p className="text-[#333333] text-sm sm:text-sm line-clamp-3 text-wrap">
              {parse(event.mainSection.shortDescription || " ")}
            </p>
          </div>
          {/* Location */}
          <div className="flex items-start gap-1 text-gray-600 text-sm sm:text-sm">
            <LocationOn className="w-4 h-4 sm:w-5 sm:h-5 min-w-[16px] sm:min-w-[20px] text-[#333333]" />
            <span className="text-[#6C5D2F] text-wrap">
              {event?.mainSection?.location?.address}
            </span>
          </div>
        </div>
      </div>

      <div className="flex flex-wrap justify-between items-center mt-4 px-4">
        <div className="pl-10">
          {eventtype === "chadawa" && (
            <div className="flex h-14">
              {positions.map((position, index) => {
                const image = itemImages[position];

                if (!image) return null; // Skip if image is undefined

                return (
                  <div
                    key={position}
                    className={`relative -ml-10 transition-all duration-300 hover:scale-105 hover:translate-y-[-10px]`}
                    style={{
                      zIndex: index,
                    }}
                  >
                    <img
                      src={image.url}
                      alt={image.alt}
                      className="w-14 h-14 rounded-xl object-cover shadow-sm hover:shadow-md transition-shadow"
                    />
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <button
          className={`font-semibold px-5 py-2 rounded-full transition-transform duration-300 text-md md:text-sm lg:text-base ${
            eventStatus === "EVENT_END"
              ? "bg-gray-400 text-gray-700 cursor-not-allowed"
              : "bg-[#FF5722] text-white hover:scale-105 hover:shadow-lg"
          }`}
          onClick={() => {
            if (isInProgress || isUpcoming) {
              onButtonClick(event.id);
              pushGTMEvent(BOOK_PUJA_PARTICIPATE_LANDING_PAGE, {
                event_value: event.mainSection.name,
              });
            }
          }}
        >
          {isInProgress
            ? translations.participateNow
            : isUpcoming
            ? translations.eventUpcoming
            : translations.eventEnded}
        </button>
      </div>
    </div>
  );
};

export default EventCard;
